<template>
    <div class="w-layout-grid content-3-col-grid">
        <div class="side-content"></div>
        <div class="middle-content middle-content-initial-state">
            <div class="mt-3">
                <div class="course-top">
                    <div class="course-name-block">
                        <h2 class="mt-3 section-title">{{ title }}</h2>
                    </div>
                    <div class="justify-content-end">
                        <button class="btn btn-primary mb-2" @click="isCreateActive" v-if="addNewTemplate === false">
                            {{ trans('email-editor.new-template') }}
                        </button>
                    </div>
                </div>
                <select class="form-control" v-model="selectedEmailTemplateType" v-if="addNewTemplate === false"
                        @change="clearErrors()">
                    <option value="0" disabled selected>{{ trans('forms.email_templates.select_template') }}</option>
                    <optgroup v-for="(templates,templateGroup) in selectOptions"
                              :label="trans('forms').email_templates.templates.types[templateGroup]">
                        <option v-for="(template,type) in templates" :key="type" :value="type">{{
                                trans('forms').email_templates.templates.defaults[template.slug] || template.name
                            }}
                        </option>
                    </optgroup>
                </select>
                <div v-if="selectedEmailTemplateType || addNewTemplate === true" class="row mt-3">
                    <div class="col-12">
                        <div class="row">
                            <div class="form-group col-sm-6" v-if="addNewTemplate === true">
                                <label for="type">{{ trans('forms').email_templates.fields.type }}*</label>
                                <select type="text" class="form-control" id="type"
                                        @change="updateTokens"
                                        v-model="modal.type">
                                    <option v-for="emailTemplateType in emailTemplateTypes"
                                            :value="emailTemplateType.id">
                                        {{ trans('forms').email_templates.templates.types[emailTemplateType.name] }}
                                    </option>
                                </select>
                                <small v-if="error.type" class="text-danger">{{ error.type[0] }} </small>
                            </div>
                            <div class="form-group " v-if="addNewTemplate === true || modal.removable"
                                 :class="(addNewTemplate) ? 'col-sm-6' : 'col-sm-12'">
                                <label for="name">{{ trans('forms').email_templates.fields.name }}*</label>
                                <input type="text" class="form-control" id="name"
                                       v-model="modal.name"/>
                                <small v-if="error.name" class="text-danger">{{ error.name[0] }} </small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-sm-6">
                                <label for="from_name">{{
                                        trans('forms').email_templates.fields.email_from_name
                                    }}</label>
                                <input type="text" class="form-control" id="from_name"
                                       v-model="modal.from_name"/>
                                <small v-if="error.from_name" class="text-danger">{{ error.from_name[0] }} </small>
                            </div>
                            <div class="form-group col-sm-6">
                                <label for="from">{{ trans('forms').email_templates.fields.email_from_address }}</label>
                                <input type="text" class="form-control" id="from"
                                       v-model="modal.from"/>
                                <small v-if="error.from" class="text-danger">{{ error.from[0] }} </small>
                            </div>
                        </div>
                        <br>
                        <ul class="nav nav-tabs">
                            <li class="nav-item" v-for="language in sortedLanguages" :key="'tab-' + language">
                                <a :href="'#' + language" class="nav-link pl-5 pr-5"
                                   @click.prevent="setActive(language)"
                                   :class="{ active: isActive(language) }" data-bs-toggle="tab"
                                   style="font-size: 18px">{{ language.toUpperCase() }}</a>
                            </li>
                        </ul>
                        <br>
                        <div class="tab-content">
                            <div v-for="language in sortedLanguages"
                                 :key="'editor-' + language"
                                 class="tab-pane fade"
                                 :class="{ 'active show': isActive(language) }" :id="language">
                                <div class="row">
                                    <div class="form-group col-sm-12">
                                        <label for="subject">{{
                                                trans('forms').email_templates.fields.subject + (language === 'en' ? '*' : '')
                                            }}</label>
                                        <input type="text" class="form-control"
                                               :id="'subject' + (language === 'en' ? '' : '_' + language)"
                                               v-model="modal['subject' + (language === 'en' ? '' : '_' + language)]"/>
                                        <small v-if="error['subject' + (language === 'en' ? '' : '_' + language)]"
                                               class="text-danger">
                                            {{ error['subject' + (language === 'en' ? '' : '_' + language)][0] }}
                                        </small>
                                    </div>
                                    <div class="form-group col-sm-12">
                                        <label>{{ trans('forms').email_templates.fields.body  + (language === 'en' ? '*' : '')}}</label>
                                        <ckeditor @ready="onEditorReady" :editor="editor" :config="htmlEditorConfig"
                                                  class="form-control"
                                                  v-model="modal['body' + (language === 'en' ? '' : '_' + language)]"/>
                                        <small v-if="error['body' + (language === 'en' ? '' : '_' + language)]"
                                               class="text-danger">
                                            {{ error['body' + (language === 'en' ? '' : '_' + language)][0] }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <button type="button"
                                        @click="deleteTemplate"
                                        class="btn btn-success float-left"
                                        :disabled="isDisabled"
                                        v-if="addNewTemplate === false && modal.removable"
                                >
                                    {{ trans('forms').delete }}
                                </button>
                                <button class="btn btn-success float-left" v-if="addNewTemplate === true"
                                        @click="() => {addNewTemplate = false; clearErrors()}"
                                >{{ trans('forms').cancel }}
                                </button>
                                <button type="button" @click="saveTemplate"
                                        class="btn btn-success float-right"
                                        :disabled="isDisabled">
                                    {{
                                        (isDisabled) ? trans('forms').email_templates.all_required : trans('forms').save
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="side-content right side-right-initial-state">
            <div class="fixed-parent">
                <div class="fixed pr-2">
                    <template v-if="selectedEmailTemplateType || addNewTemplate === true">
                        <h4>Tokens</h4>
                        <div v-for="(token, index) in modal.tokens" :key="'tokens-'+index+token"
                             class="d-flex align-items-center position-relative">
                            <p style="margin-top: 0">[{{ token }}]</p>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomEditor from "../includes/ck-editor/ck-editor-custom";
import toastr from 'toastr';

export default {
    name: "EmailTemplateEditor",
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        selectOptions: {},
        emailTemplates: {},
        selectedEmailTemplateType: 0,
        editor: CustomEditor,
        htmlEditorConfig: {
            language: document.documentElement.lang,
            startupFocus: true,
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'http://',
            },
        },
        activeItem: 'en',
        addNewTemplate: false,
        tokenName: '',
        error: {},
        emailTemplateTypes: [],
        newEmailTemplates: null,
    }),
    props: {
        title: {
            type: String,
            required: true,
        },
        languages: {
            type: Array,
            default: () => [],
        }
    },
    created() {
        this.newEmailTemplates = this.getNewEmptyTemplate();
        this.getEmailTemplates();
        this.getEmailTemplateTypes();
        toastr.options = {
            "closeButton": true,
            "tapToDismiss": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-top-right",
            "preventDuplicates": false,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };
    },
    computed: {
        sortedLanguages: function () {
            return this.languages.sort((a, b) => a === 'en' ? -1 : 0)
        },
        modal: {
            get() {
                if (this.addNewTemplate) {
                    return this.newEmailTemplates;
                }
                return this.emailTemplates[this.selectedEmailTemplateType];
            },
            set(val) {
                console.dir(val)
                if (this.addNewTemplate) {
                    this.newEmailTemplates = {...val};
                } else {
                    this.emailTemplates[this.selectedEmailTemplateType] = val;
                }
            }
        },
        isDisabled: function () {
            if (this.addNewTemplate) {
                return Boolean(this.newEmailTemplates.type === 0
                    || Object.keys(this.newEmailTemplates).filter(elem =>
                        !this.newEmailTemplates[elem]?.length
                        && ['name', 'subject', 'body'].includes(elem)
                    ).length)
            } else {
                return false
            }
        }
    },
    methods: {
        getNewEmptyTemplate() {
            const newTemplate = {
                type: 0,
                name: '',
                from_name: '',
                from: '',
                tokens: []
            };

            for (const language of this.sortedLanguages) {
                newTemplate['subject' + (language === 'en' ? '' : '_' + language)] = '';
                newTemplate['body' + (language === 'en' ? '' : '_' + language)] = '';
            }
            return newTemplate;
        },
        getEmailTemplateTypes() {
            let $end = '/api/available-email-template-types';
            let self = this;
            axios.get($end, {params: {}}).then(function (response) {
                response = response.data
                self.emailTemplateTypes = [];
                // console.log(response)
                response.data.forEach(function (emailTemplateType) {
                    let data = {
                        id: emailTemplateType.id,
                        name: emailTemplateType.name,
                        tokens: emailTemplateType.tokens
                    }

                    self.emailTemplateTypes.push(data);
                });
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        async getEmailTemplates() {
            let $end = '/api/email-template';
            let self = this;
            await axios.get($end, {params: {}}).then(function (response) {
                response = response.data
                self.emailTemplates = {}
                self.selectOptions = {}
                // console.log(response)
                response.data.forEach(function (emailTemplate) {
                    let data = {
                        id: emailTemplate.id,
                        type: emailTemplate.type,
                        slug: emailTemplate.slug,
                        group: emailTemplate.type,
                        name: emailTemplate.name,
                        from: emailTemplate.from,
                        from_name: emailTemplate.from_name,
                        // subject: emailTemplate.subject,
                        // body: emailTemplate.body,
                        // subject_de: emailTemplate.subject_de,
                        // body_de: emailTemplate.body_de || '',
                        tokens: emailTemplate.tokens,
                        removable: !!emailTemplate.removable,
                    }

                    for (const language of self.sortedLanguages) {
                        data['subject' + (language === 'en' ? '' : '_' + language)] = emailTemplate['subject' + (language === 'en' ? '' : '_' + language)] || '';
                        data['body' + (language === 'en' ? '' : '_' + language)] = emailTemplate['body' + (language === 'en' ? '' : '_' + language)] || '';
                    }

                    if (typeof self.selectOptions[data.group] == 'undefined') {
                        self.selectOptions[data.group] = {}
                    }
                    self.selectOptions[data.group][data.id] = {
                        type: emailTemplate.id,
                        slug: emailTemplate.slug,
                        name: emailTemplate.name,
                    }
                    self.emailTemplates[data.id] = data
                });
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        clearErrors() {
            this.error = {}
        },
        errors(err) {
            this.error = err.response.data.errors || {};
        },
        async saveTemplate() {
            let $end, $method, $data;
            let self = this;

            if (!this.addNewTemplate
                && (!this.selectedEmailTemplateType || !this.emailTemplates[this.selectedEmailTemplateType].id)
            ) {
                return false;
            }

            if (this.addNewTemplate) {
                $end = '/api/email-template';
                $method = 'POST';
                $data = this.newEmailTemplates;
            } else {
                $end = '/api/email-template/' + this.emailTemplates[this.selectedEmailTemplateType].id;
                $method = 'PUT';
                $data = this.emailTemplates[this.selectedEmailTemplateType];
            }
            axios({
                url: $end,
                method: $method,
                data: $data,
            }).then(async function (response) {
                await self.getEmailTemplates()
                self.clearErrors()
                self.addNewTemplate = false
                toastr.success(trans.forms.email_templates['save_success']);
                self.selectedEmailTemplateType = response.data.templateId;
            }).catch(err => {
                console.log(err);
                self.errors(err)
                toastr.error(trans.forms.email_templates['save_error']);
                this.$data.loader = false;
            });
        },
        deleteTemplate() {
            if (!this.selectedEmailTemplateType || !this.emailTemplates[this.selectedEmailTemplateType].id) {
                return false
            }

            let $end = '/api/email-template/' + this.emailTemplates[this.selectedEmailTemplateType].id
            let self = this
            // console.log(this.courseEventsSchedule)
            self.$swal.fire({
                title: trans.forms.email_templates.messages.delete_confirm,
                text: trans.forms.email_templates.messages.delete_message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#f77f00',
                cancelButtonColor: 'aaaaaa',
                cancelButtonText: window.trans.messages.No,
                confirmButtonText: window.trans.messages.Yes,
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete($end, this.emailTemplates[this.selectedEmailTemplateType]).then(function () {
                        self.getEmailTemplates();
                        self.clearErrors();
                        self.selectedEmailTemplateType = 0;
                        toastr.success(trans.forms.email_templates['delete_success']);
                    }).catch(err => {
                        console.log(err);
                        self.errors(err);
                        toastr.error(trans.forms.email_templates['save_error']);
                        this.$data.loader = false;
                    });
                }
            })
        },
        onEditorReady(editor) {
            editor.editing.view.focus();
        },
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            this.activeItem = menuItem
        },
        isCreateActive() {
            this.newEmailTemplates = this.getNewEmptyTemplate();
            // Object.keys(this.newEmailTemplates).map(elem => this.newEmailTemplates[elem] = '')
            this.newEmailTemplates.tokens = []
            this.addNewTemplate = true
        },
        updateTokens() {
            const templateType = this.emailTemplateTypes.filter((arrayElement) =>
                arrayElement.id === this.modal.type);

            if (templateType.length) {
                this.newEmailTemplates.tokens = [...templateType[0].tokens];
            } else {
                this.newEmailTemplates.tokens = [];
            }

        }
    }
}
</script>

<style scoped>
.d-flex {
    display: flex;
}

.input-token {
    border: 0;
    border-bottom: 1px solid;
    margin-bottom: 1vw;
    outline: none;
}

.ck.ck-content {
    border: 1px solid #ced4da;
    border-radius: 0.25rem !important;
    height: 50vh !important;
}

.buton-stergere {
    position: absolute;
    right: -2vw;
    height: 20px;
    width: 20px;
    min-height: 0;
    top: 0.1vw;
    content: url('/images/delete-orange.png');
}

button:disabled {
    background-color: transparent;
    border: 1px solid orange;
    color: orange;
}

.buton-stergere:hover {
    content: url('/images/delete-red.png');
}
</style>
